import { ButtonPrimary, ButtonPseudo, InputText, Popup } from '@ui/src';

import { AccountsPopupsTypes } from './types';

import cn from './styles.module.css';

const AccountsPopups = ({
  setDirtyPopupVisible,
  handleClose,
  dirtyPopupVisible,
  creditBlock,
  setCreditBlockConfirmationVisible,
  setCreditBlock,
  onBlockCredit,
  topupButtonText,
  creditBlockConfirmationVisible,
  blockUblockCreditError,
  account,
  setComment,
  setCommentPopupVisible,
  commentPopupVisible,
  comment,
  closeOpenError,
  commentPopupButtonText,
  onClose,
  openInProgress,
  closeInProgress,
  debitBlock,
  setDebitBlockConfirmationVisible,
  setDebitBlock,
  onBlockDebit,
  blockButtonText,
  debitBlockConfirmationVisible,
  blockUblockDebitError,
}: AccountsPopupsTypes) => (
  <>
    <Popup
      title="You have unsaved changes"
      description=""
      onCancelClick={() => setDirtyPopupVisible(false)}
      onOkClick={handleClose}
      cancelButtonText="Cancel"
      okButtonText="Close"
      isVisible={dirtyPopupVisible}
      parent={document.getElementById('dirty-popup') as HTMLElement}
    />

    <Popup
      title={`${creditBlock ? 'Block' : 'Unblock'} the top-up of this account?`}
      description=""
      onCancelClick={() => {
        setCreditBlockConfirmationVisible(false);
        setCreditBlock(!creditBlock);
      }}
      onOkClick={() => onBlockCredit(creditBlock as boolean)}
      cancelButtonText="Cancel"
      okButtonText={topupButtonText}
      isVisible={creditBlockConfirmationVisible}
      parent={document.getElementById('dirty-popup') as HTMLElement}
    >
      <div>
        {blockUblockCreditError && (
          <div className={`${cn.accountError} ${cn.blockError}`}>
            {blockUblockCreditError}
          </div>
        )}
      </div>
    </Popup>

    <Popup
      title={`You want to ${account?.closed ? 'open' : 'close'} this account?`}
      description=""
      onCancelClick={() => {
        setComment('');
        setCommentPopupVisible(false);
      }}
      isVisible={commentPopupVisible}
      parent={document.getElementById('dirty-popup') as HTMLElement}
    >
      <>
        <div className={cn.commentWrapper}>
          <InputText
            name="comment"
            value={comment}
            placeholder="Enter a comment"
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        {closeOpenError && (
          <div className={cn.accountError}>{closeOpenError}</div>
        )}
        <div className={cn.controlsWrapper}>
          <ButtonPseudo
            text="Cancel"
            onClick={() => {
              setComment('');
              setCommentPopupVisible(false);
            }}
            bold
          />
          <ButtonPrimary
            text={commentPopupButtonText}
            onClick={onClose}
            disabled={openInProgress || closeInProgress || !comment}
            bold
          />
        </div>
      </>
    </Popup>
    <Popup
      title={`${
        debitBlock ? 'Block' : 'Unblock'
      } the withdrawals of this account?`}
      description=""
      onCancelClick={() => {
        setDebitBlockConfirmationVisible(false);
        setDebitBlock(!debitBlock);
      }}
      onOkClick={() => onBlockDebit(debitBlock as boolean)}
      cancelButtonText="Cancel"
      okButtonText={blockButtonText}
      isVisible={debitBlockConfirmationVisible}
      parent={document.getElementById('dirty-popup') as HTMLElement}
    >
      <div>
        {blockUblockDebitError && (
          <div className={`${cn.accountError} ${cn.blockError}`}>
            {blockUblockDebitError}
          </div>
        )}
      </div>
    </Popup>
  </>
);

export default AccountsPopups;
